module.exports = __webpack_public_path__ + "img/safty_kanri.284c21d9.jpg";